export default class UebersichtMonitoringPeriodeDto {

  constructor(json) {
    if (json) {
      this.json = json
      this.periodeId = json.periodeId
      this.start = json.start
      this.ende = json.ende
      this.anzahlPendent = json.anzahlPendent
      this.anzahlUeberschritten = json.anzahlUeberschritten
      this.kontingent = json.kontingent
      this.verbrauch = json.verbrauch
      // GP
      this.kontingentId = json.kontingentId
    } else {
      this.json = {}
    }
  }

  get startEnde() {
    return `${formatDate(this.start)} - ${formatDate(this.ende)}`
  }

  get anteil() {
    return Math.round(this.verbrauch / this.kontingent * 100)
  }
}
